module.exports = __webpack_public_path__ + "img/icon-fom-payout-setting.149177b7.png";